(function (w, $) {
    const cookie = (w.cms && w.cms.cookie) || $.cookie;

    $(function () {
        cookie('selectedDeliveryAddressId', null);
        setupNewsletterButtonListeners();
    });

    function setupNewsletterButtonListeners() {
        const $btnSubscribe = $('#btnSubscribeToNewsletters');
        const $btnUnsubscribe = $('#btnUnsubscribeToNewsletters');
        const $privatePolicy = $('#privacy-policy');

        $btnSubscribe.on('click', function () {
            handleNewsletterClick($btnSubscribe, true);
            notify(w.TopFormText.SubscribeSuccess, 'success');
            triggerFocusoutEvent($btnSubscribe);
            toggleButtonSubscribe(true, $btnSubscribe, $btnUnsubscribe, $privatePolicy);
        });
    }

    function handleNewsletterClick($clickedButton, isRecipient) {
        const orderId = $clickedButton.data('orderid');
        $.publicFetch({
            handler: 'UserData',
            data: { a: 'SaveNewsletterSubscription', isRecipient: isRecipient, orderId: orderId },
            type: 'POST',
        });
    }

    function toggleButtonSubscribe(subscribe, $btnSubscribe, $btnUnsubscribe, $privatePolicy ) {
        if (subscribe) {
            $btnSubscribe.hide();
            $privatePolicy.hide();
            $btnUnsubscribe.show();
        }
        else {
            $btnSubscribe.show();
            $privatePolicy.show();
            $btnUnsubscribe.hide();
        }
    }

    function notify(message, type) {
        var notificationChannel = typeof (type) === 'string' && type ? 'notification.' + type : 'notification';
        w.PubSub.publish(notificationChannel, message);
    }

    function triggerFocusoutEvent($button) {
        $button.trigger('focusout');    
    }

})(window, jQuery);
